/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Определяет тип содержимого документа.
 * @export
 * @enum {string}
 */
export var FxIdDomainEntitiesDocumentsContentType;
(function (FxIdDomainEntitiesDocumentsContentType) {
    FxIdDomainEntitiesDocumentsContentType[FxIdDomainEntitiesDocumentsContentType["Unspecified"] = 0] = "Unspecified";
    FxIdDomainEntitiesDocumentsContentType[FxIdDomainEntitiesDocumentsContentType["Markdown"] = 1] = "Markdown";
    FxIdDomainEntitiesDocumentsContentType[FxIdDomainEntitiesDocumentsContentType["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainEntitiesDocumentsContentType || (FxIdDomainEntitiesDocumentsContentType = {}));
export function instanceOfFxIdDomainEntitiesDocumentsContentType(value) {
    for (const key in FxIdDomainEntitiesDocumentsContentType) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainEntitiesDocumentsContentType, key)) {
            if (FxIdDomainEntitiesDocumentsContentType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainEntitiesDocumentsContentTypeFromJSON(json) {
    return FxIdDomainEntitiesDocumentsContentTypeFromJSONTyped(json, false);
}
export function FxIdDomainEntitiesDocumentsContentTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainEntitiesDocumentsContentTypeToJSON(value) {
    return value;
}
export function FxIdDomainEntitiesDocumentsContentTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainEntitiesDocumentsContentType.js.map